import React, { Component } from "react";
import io from "socket.io-client";
import {
  main_url,
  remote_url,
  removeCookieData,
  getUserId,
  imageError,
  fetchProfilePhoto,
  FALLBACK_AVATAR,
} from "../../utils/CommonFunction";
import { withRouter } from "react-router-dom";
import { getCookieData } from "../../utils/CommonFunction";
import { getHeaders } from "../../utils/apiHelper";

// const id = getUserId("user_info");

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: getCookieData("user_info"),
      user_id: getUserId("user_info"),
      noti_count: 0,
      time: "",
      // NOTE: the socket handler writes benefit_allownace_noti_count (typo)
      // but render() reads benefit_allowance_noti_count, so socket updates for
      // this one badge never display. Left as-is; fixing it changes behaviour.
      benefit_allownace_noti_count: 0,
      benefit_allownace_time: "",
      benefit_allowance_noti_count: 0,
      wedding_benefit_count: 0,
      wedding_benefit_time: "",
      funeral_benefit_count: 0,
      funeral_benefit_time: "",
      external_benefit_count: 0,
      external_benefit_time: "",
      medical_benefit_count: 0,
      medical_benefit_time: "",
      teamBuilding_benefit_count: 0,
      teamBuilding_benefit_time: "",
      other_benefit_count: 0,
      other_benefit_time: "",
      count: 0,
      isOpen: true,
      isOpenDashboard: false,
      isHR: false,
      userPhoto: "",
      userInfo: null,
    };
  }

  async componentDidMount() {
    const id = localStorage.getItem("user_id");

    console.log("Here is id in Navbar.jsx >>>>>>>>>>>>>>", id);
    await this.loadUserInfo(id);

    // document.querySelector(".minimalize-styl-2").addEventListener("click",this.afterClick)
    document
      .querySelector(".minimalize-styl-2")
      .addEventListener("click", this.clickButton);
    try {
      console.log(
        "Here is user id -------------- in navbar.jsx",
        this.state.user.user_id
      );
      const socket_noti = io(
        `${main_url}hrms_noti?user_id=${this.state.user.user_id}`
      );
      this.getNotiCount();
      socket_noti.on("noti", (count) => {
        this.setState({
          noti_count: count.count,
          time: count.time,
        });
      });
      this.getNotiCountForOneUser_child();
      socket_noti.on("benefit_and_allowance_noti", (count) => {
        this.setState({
          benefit_allownace_noti_count: count.count,
          benefit_allownace_time: count.time,
        });
      });
      //@kpk
      this.getNotiCountForOneUser_wedding();
      socket_noti.on("benefit_and_allowance_noti", (count) => {
        this.setState({
          wedding_benefit_count: count.count,
          wedding_benefit_time: count.time,
        });
      });
      //@kpk
      this.getBenefitNotiCount_funeral();
      socket_noti.on("benefit_and_allowance_noti", (count) => {
        this.setState({
          funeral_benefit_count: count.count,
          funeral_benefit_time: count.time,
        });
      });
      //@kpk
      this.getBenefitNotiCount_external();
      socket_noti.on("benefit_and_allowance_noti", (count) => {
        this.setState({
          external_benefit_count: count.count,
          external_benefit_time: count.time,
        });
      });
      //@kpk
      this.getBenefitNotiCount_medical();
      socket_noti.on("benefit_and_allowance_noti", (count) => {
        this.setState({
          medical_benefit_count: count.count,
          medical_benefit_time: count.time,
        });
      });
      //@kpk
      this.getBenefitNotiCount_teamBuilding();
      socket_noti.on("benefit_and_allowance_noti", (count) => {
        this.setState({
          teamBuilding_benefit_count: count.count,
          teamBuilding_benefit_time: count.time,
        });
      });
      //@kpk
      this.getBenefitNotiCount_other();
      socket_noti.on("benefit_and_allowance_noti", (count) => {
        this.setState({
          other_benefit_count: count.count,
          other_benefit_time: count.time,
        });
      });
      // this.handleClick = this.handleClick().bind(this);
      // this.handleClickThrottled = throttle(this.handleClick, 1000);
    } catch (error) {
      console.log(error);
    }
  }
  // A failed request used to escape componentDidMount as an uncaught error:
  // "TypeError: Failed to fetch" when the API is unreachable, or "res[0] of
  // null" on a 401. Either one took the whole app down, so keep it contained.
  async loadUserInfo(id) {
    let userInfo = null;
    try {
      const response = await fetch(main_url + `main/getUserInfo/${id}`, {
        headers: getHeaders(),
      });
      if (response.ok) {
        const res = await response.json();
        if (Array.isArray(res) && res.length > 0) userInfo = res[0];
      } else {
        console.log("getUserInfo responded", response.status);
      }
    } catch (err) {
      console.log("getUserInfo failed", err);
    }

    if (this.unmounted) return;
    this.setState({ userInfo });
    if (userInfo != null && userInfo.avatar != null) {
      await this.getProfile(userInfo.avatar);
    } else {
      this.setState({ userPhoto: FALLBACK_AVATAR });
    }
  }

  async getProfile(avatar) {
    const photoUrl = await fetchProfilePhoto(avatar);
    if (this.unmounted) {
      if (photoUrl) URL.revokeObjectURL(photoUrl);
      return;
    }
    this.objectUrl = photoUrl;
    this.setState({ userPhoto: photoUrl || FALLBACK_AVATAR });
  }

  componentWillUnmount() {
    this.unmounted = true;
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
  }

  // componentDidUpdate() {
  //     if (window.location.pathname.includes(`/${this.state.user.user_id}`) || window.location.pathname.includes('/dashboard') ) {
  //     if (this.state.isOpenDashboard) {
  //         document.body.classList.add('mini-navbar')
  //     } else {
  //         console.log("open")
  //         document.body.classList.remove('mini-navbar')
  //     }
  // }else{

  //     if (this.state.isOpen) {
  //         document.body.classList.remove('mini-navbar')
  //     } else {
  //         document.body.classList.add('mini-navbar')
  //     }
  // }

  // }

  // Each of these used to reject on a network failure -- an unhandled promise
  // rejection, since they are called without await -- and to throw on
  // `data.count` whenever the response was not ok, because
  // `if (res.ok) return res.json()` yields undefined. Notification counts are
  // non-critical: on failure leave the badge at its current value.
  fetchNotiCount = async (route, countKey, timeKey) => {
    try {
      const res = await fetch(`${main_url}noti/${route}/${this.state.user_id}`, {
        headers: getHeaders(),
      });
      if (!res.ok) {
        console.log(`noti/${route} responded`, res.status);
        return;
      }
      const data = await res.json();
      if (this.unmounted || !data) return;
      this.setState({ [countKey]: data.count, [timeKey]: data.time });
    } catch (err) {
      console.log(`noti/${route} failed`, err);
    }
  };

  getNotiCount = () =>
    this.fetchNotiCount(
      "getNotiCountForOneUser",
      "noti_count",
      "time"
    );
  // @hmh
  // child_benefit

  getNotiCountForOneUser_child = () =>
    this.fetchNotiCount(
      "getNotiCountForOneUser_child",
      "benefit_allowance_noti_count",
      "benefit_allownace_time"
    );

  readNoti = () => {
    this.props.history.push("/notification");
    setTimeout(() => {
      fetch(`${main_url}noti/readNotiBenefit`, {
        headers: getHeaders(),
      }).catch((err) => console.log("readNotiBenefit failed", err));
      window.location.reload();
    }, 3000);

    // const query = queryString.parse(window.location.search)
    // if (window.location.pathname !== '/notification') {
  };

  //@kpk
  getNotiCountForOneUser_wedding = () =>
    this.fetchNotiCount(
      "getNotiCountForOneUser_wedding",
      "wedding_benefit_count",
      "wedding_benefit_time"
    );
  //@kpk
  getBenefitNotiCount_funeral = () =>
    this.fetchNotiCount(
      "getNotiCountForOneUser_funeral",
      "funeral_benefit_count",
      "funeral_benefit_time"
    );
  //@kpk
  getBenefitNotiCount_external = () =>
    this.fetchNotiCount(
      "getNotiCountForOneUser_external",
      "external_benefit_count",
      "external_benefit_time"
    );
  //@kpk
  getBenefitNotiCount_medical = () =>
    this.fetchNotiCount(
      "getNotiCountForOneUser_medical",
      "medical_benefit_count",
      "medical_benefit_time"
    );

  //@kpk
  getBenefitNotiCount_teamBuilding = () =>
    this.fetchNotiCount(
      "getNotiCountForOneUser_teamBuilding",
      "teamBuilding_benefit_count",
      "teamBuilding_benefit_time"
    );
  //@kpk
  getBenefitNotiCount_other = () =>
    this.fetchNotiCount(
      "getNotiCountForOneUser_other",
      "other_benefit_count",
      "other_benefit_time"
    );
  clickButton = () => {
    document.body.classList.toggle("mini-navbar");
  };
  render() {
    let count =
      parseInt(this.state.count) +
      parseInt(this.state.benefit_allowance_noti_count) +
      parseInt(this.state.wedding_benefit_count) +
      parseInt(this.state.funeral_benefit_count) +
      parseInt(this.state.external_benefit_count) +
      parseInt(this.state.medical_benefit_count) +
      parseInt(this.state.teamBuilding_benefit_count) +
      parseInt(this.state.other_benefit_count);

    let count1 = count + parseInt(this.state.noti_count);

    return (
      <div>
        <div className="row border-bottom">
          <nav className="navbar navbar-static-top" role="navigation">
            <div className="navbar-header" style={{ marginTop: "8px" }}>
              <div className="minimalize-styl-2 btn btn-primary">
                <i className="fa fa-bars"></i>
              </div>
            </div>
            <div className="nav  navbar-left">
              <h2 className="font-bold">HR Management System</h2>
            </div>

            <div
              style={{
                marginRight: "40px",
              }}
            >
              <ul
                className="nav navbar-top-links navbar-right"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <li className="dropdown">
                  <a
                    className="dropdown-toggle count-info"
                    data-toggle="dropdown"
                    href="#"
                  >
                    <i className="fa fa-bell">
                      {count1 > 0 ? (
                        <span className="label noti_label">{count1}</span>
                      ) : (
                        ""
                      )}
                    </i>
                  </a>
                  {count1 > 0 ? (
                    <ul className="dropdown-menu dropdown-alerts">
                      <li>
                        <a href="/notification">
                          <div>
                            <i className="fas fa-envelope-open-text"></i>
                            &nbsp;&nbsp; You have {this.state.noti_count} help
                            desk message(s).
                            <span className="pull-right text-muted small">
                              {this.state.time} ago
                            </span>
                          </div>
                        </a>
                      </li>
                      <li>
                        {/* <a href='/notification' > */}
                        <a href="#" onClick={this.readNoti}>
                          <div>
                            <i className="fas fa-envelope-open-text"></i>
                            &nbsp;&nbsp; You have {count} benefit message(s).
                            <span className="pull-right text-muted small">
                              {this.state.benefit_allowance_noti_count} ago
                            </span>
                          </div>
                        </a>
                      </li>
                    </ul>
                  ) : (
                    ""
                  )}
                </li>
                <li
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginRight: "20px",
                  }}
                >
                  <img
                    // alt="logo"
                    className="logostyle"
                    onError={imageError}
                    // src={this.state.user.avatar ? main_url + `dashboard/getProfile/`+  this.state.user.avatar : 'assets/img/SeekPng.com_profile-icon-png_9665493.png'}
                    // src={'assets/img/SeekPng.com_profile-icon-png_9665493.png'}
                    src={this.state.userPhoto || FALLBACK_AVATAR}
                    alt={"profile"}
                    style={{
                      width: "57px",
                      height: "57px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />

                  <div
                    style={{
                      margin: "0",
                      padding: "0",
                    }}
                  >
                    <p
                      style={{
                        margin: "0",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      {this.state.user ? this.state.user.fullname : ""}
                    </p>

                    <p
                      style={{
                        margin: "0",
                        padding: "0",
                      }}
                    >
                      {this.state.user ? this.state.user.designations : ""}
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    );
  }
}

export default withRouter(NavBar);

{
  /* <div>
                                                        <i className="fas fa-envelope-open-text"></i>
                                                        &nbsp;&nbsp;
                                                You have {this.state.benefit_allowance_noti_count} benefit and allowance message(s).
                                                <span className="pull-right text-muted small">{this.state.benefit_allownace_time} ago</span>
                                                    </div> */
}
